import request from '@/utils/request';
import { buildRegionIndex } from './distributionRegion';
var pending;
export function loadDistributionRegions() {
  if (!pending) {
    pending = request({
      url: '/admin/merchant/city/region/city/tree',
      method: 'get'
    }).then(buildRegionIndex).catch(function (error) {
      pending = null;
      throw error;
    });
  }
  return pending;
}